import { watch, onUnmounted } from 'vue';

/**
 * PC 스크롤 잠금 및 스크롤바 너비 보정 Composable
 * @param {Ref<boolean>} isLocked - 스크롤 잠금 상태를 제어하는 반응형 변수
 */
export const usePCScrollLock = (isLocked) => {
  const lockScroll = () => {
    // 이미 잠겨있으면 패스 (중복 스타일 적용 방지)
    if (document.body.style.overflow === 'hidden') return;

    // 1. 스크롤바 너비 계산
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // 2. Body에 padding-right 적용하여 레이아웃 밀림 방지
    // (기존 padding이 있다면 저장해둠 - 하지만 보통 body에 padding-right는 없음)
    const originalPaddingRight = document.body.style.paddingRight || '';
    document.body.dataset.originalPaddingRight = originalPaddingRight; // 데이터 속성에 저장

    if (scrollbarWidth > 0) {
      // 기존 패딩이 있으면 계산해서 더해줄 수도 있지만, 여기선 단순 대체 후 복구 전략 사용
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    // 3. 스크롤 잠금
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    // 스타일 초기화
    const originalPaddingRight = document.body.dataset.originalPaddingRight;
    if (originalPaddingRight !== undefined) {
      document.body.style.paddingRight = originalPaddingRight;
      delete document.body.dataset.originalPaddingRight;
    } else {
      document.body.style.paddingRight = '';
    }

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  // 상태 감지
  watch(
    isLocked,
    (val) => {
      if (val) {
        lockScroll();
      } else {
        unlockScroll();
      }
    },
    { immediate: true },
  );

  // 컴포넌트 언마운트 시 안전하게 잠금 해제
  onUnmounted(() => {
    unlockScroll();
  });

  return {
    lockScroll,
    unlockScroll,
  };
};
